<template>
  <div class="cmp-elastic-product-details utlz-reset utlz-row">
    <!-- BESPOKE: Changed col-md-4 to col-md-5 -->
      <div class="utlz-col-md-5 column-left">
        <!-- END BESPOKE -->
        <utlz-gallery :product="productDetails"></utlz-gallery>
      </div>

      
      <!-- BESPOKE: Changed col-md-8 to col-md-7 -->
      <div class="utlz-col-md-7 column-right product-details-column">
        <!-- END BESPOKE -->
          <div class="product-information">
            <!-- BESPOKE: Added product code label and moved it above the prod title -->
            <div class="product-code">
                <span v-translation="{ code: 'label_product_code', type: 'label' }"></span>: 
                <span>{{productDetails.id}}</span>
            </div>
            <!-- END BESPOKE -->
            <h1>{{productDetails.shortDescription}}</h1>            
            <div class="ph-product-price" v-if="productDetails.prices.length">
                <utlz-product-price
                    :prices="productDetails.prices[0]"
                ></utlz-product-price>
            </div>

            <!-- BESPOKE ROOD -->
            <div v-if="advicePrice" class="advice-price">
              <span>{{specValueAdvicePrice}}</span>
              <span>{{ advicePrice }}</span>
            </div>
            <!-- END BESPOKE ROOD -->

            <utlz-tabs :tabs="tabs">

              <template v-slot:description>
                <div class="prod-desc-container" :class="{ 'expandable': useCollapse, 'expanded': expanded }">
                  <div ref="productDescription" class="prod-desc-wrapper">
                    <div class="product-long-description" v-html="productDetails.longDescription">
                    </div>
                  </div>
                </div>
                <a v-if="useCollapse" @click="expanded = !expanded" class="collapse-button theme-primary">
                  <div v-if="!expanded" class="read-more">
                    <span v-translation="{ type: 'button', code: 'link_description_read_more' }"></span>
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                  </div>
                  <div v-if="expanded" class="read-less">
                    <span v-translation="{ type: 'button', code: 'link_description_read_less' }"></span>
                    <i class="fa fa-angle-up" aria-hidden="true"></i>
                  </div>
                </a>
              </template>

              <template v-slot:videos v-if="videos.length">
                <div class="product-videos">
                  <utlz-product-videos :videos="videos"></utlz-product-videos>
                </div>
              </template>

              <template v-slot:documents v-if="documents.length">
                <div class="product-documents">
                  <utlz-product-documents :documents="documents"></utlz-product-documents>
                </div>
              </template>

            </utlz-tabs>

            <utlz-group-dropdown :variants="productVariants" />

            <utlz-product-stock
              :product="productDetails"
              :stock="productDetails.stock"
              :stockTotal="productDetails.stock"
            ></utlz-product-stock>

            <!-- BESPOKE: Added barcode -->
            <div class="barcode-wrapper" v-if="barcode.length">
              <span v-translation="{type: 'label', code: 'label_barcode_label' }"></span>: 
              <span>{{ barcode }}</span>
            </div>
            <!-- END BESPOKE -->

            <div class="order-product">
              <!-- BESPOKE: Added :useTextButton="true" -->
              <utlz-order-product
                v-if="showOrderProductControl && productDetails.prices.length"
                :product="productDetails"
                :useOrderComment="useOrderLineComments && productDetails.customBooleans.SHOW_PROD_COMMENT"
                :useTextButton="true"
                >
                </utlz-order-product>
                <!-- END BESPOKE -->

                <transition name="fade">
                  <p v-if="!showOrderProductControl && showStock" class="out-of-stock-msg">
                    <i class="fa fa-warning"></i>
                    <span v-translation="{ type: 'label', code: 'label_out_of_stock' }"></span>
                  </p>
                </transition>
            </div>

            <div class="favorite">
              <utlz-favorites-control v-if="showFavorites" :product="productDetails" :useDescription="true"></utlz-favorites-control>
            </div>
          </div>
      </div>

      <!-- BESPOKE: Moved product specs down -->
      <div v-if="productProperties.length" class="product-specs utlz-col-12 margin-bottom-30">
        <div class="product-specifications">
            <h2 v-translation="{ type: 'title', code: 'title_specifications' }"></h2>
            <div class="spec-list">
              <div class="spec-item" v-for="prop in productProperties" :key="prop.key">
                <div class="spec-desc">
                  {{prop.key}}
                </div>
                <div class="spec-value">
                  {{prop.value}}
                </div>
              </div>
            </div>
          </div>
      </div>
      <!-- END BESPOKE -->

      <div v-if="showOrderProductControl && productDetails.prices.length && productVariants.length" class="utlz-col-md-12">
        <utlz-group-matrix :variants="productVariants" />
      </div>

      <div v-if="relatedProducts.upSelling.length" class="related-products upselling utlz-col-12 ">
        <utlz-product-carousel
          :products="relatedProducts.upSelling"
          :blockSize="relatedProductBlockSize"
          :title="titleUpSelling"
        ></utlz-product-carousel>
      </div>

      <div v-if="relatedProducts.crossSelling.length" class="related-products upselling utlz-col-12 ">
        <utlz-product-carousel
          :products="relatedProducts.crossSelling"
          :blockSize="relatedProductBlockSize"
          :title="titleCrossSelling"
        ></utlz-product-carousel>
      </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ProductPrice from 'src/components/webshop/product-price/ProductPrice.vue';
import OrderProduct from 'src/components/webshop/order-product/OrderProduct.vue';
import ProductStock from 'src/components/webshop/product-stock/ProductStock.vue';
import ProductGroupMatrix from 'src/components/webshop/products/product-group/ProductGroupMatrix.vue';
import ProductGroupDropdown from 'src/components/webshop/products/product-group/ProductGroupDropdowns.vue';
import FavoritesControl from 'src/components/webshop/favorites/FavoritesControl.vue';
import Gallery from 'src/components/ui/gallery/Gallery.vue';
import Tabs from 'src/components/ui/tabs/Tabs.vue';
import ProductVideos from 'src/components/webshop/products/product-videos/ProductVideos.vue';
import ProductDocuments from 'src/components/webshop/products/product-documents/ProductDocuments.vue';
import ProductCarousel from 'src/components/webshop/products/product-carousel/ProductCarousel.vue';
export default {
  components: {
    'utlz-product-price': ProductPrice,
    'utlz-order-product': OrderProduct,
    'utlz-product-stock': ProductStock,
    'utlz-group-matrix': ProductGroupMatrix,
    'utlz-group-dropdown': ProductGroupDropdown,
    'utlz-favorites-control': FavoritesControl,
    'utlz-gallery': Gallery,
    'utlz-tabs': Tabs,
    'utlz-product-carousel': ProductCarousel,
    'utlz-product-videos': ProductVideos,
    'utlz-product-documents': ProductDocuments
  },
  data () {
    return {
      expanded: false,
      productDescriptionHeight: 0,
      titleUpSelling: window.vue.translations.title.title_product_relations,
      titleCrossSelling: window.vue.translations.title.title_product_relations_cross,
      tabs: [
        { id: 'description', description: window.vue.translations.label.label_tab_product_desc, active: true, visible: false },
        { id: 'documents', description: window.vue.translations.label.label_tab_product_documents, active: false, visible: false },
        { id: 'videos', description: window.vue.translations.label.label_tab_product_videos, active: false, visible: false }
      ],
      // BESPOKE
      barcode: window.vue.translations.label.label_barcode_value,
      specValueAdvicePrice: window.vue.translations.label.label_advice_price
      // END BESPOKE
    }
  },
  watch: {
    longDescription (val) { this.tabs[0].visible = val.length > 0 },
    documents (val) { this.tabs[1].visible = val.length > 0; },
    videos (val) { this.tabs[2].visible = val.length > 0; }
  },
  computed: {
    ...mapState('productDetails', ['productDetails', 'productVariants', 'relatedProducts', 'videos']),
    ...mapGetters(['showStock', 'showPrices', 'showFavorites', 'showOrderProduct', 'stockLimit', 'useOrderLineComments', 'relatedProductBlockSize']),
    ...mapGetters('productDetails', ['documents']),
    longDescription() {
      return this.productDetails.longDescription;
    },
    useCollapse () {
      return this.productDescriptionHeight > 150;
    },
    showOrderProductControl () {
      if (!this.showPrices) {
        return false;
      } else if (this.showOrderProduct) {
        if (!this.stockLimit) {
          return true;
        } else if (this.stockLimit && this.productDetails.stock !== null) {
          return this.stockLimit && this.productDetails.stock.stockTotal > 0;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    productProperties () {
      // BESPOKE ROOD
      // Hardcoded deleted properties from the specifcations 
      let props = { ...this.productDetails.properties };
      delete props['Magazijn route'];
      delete props[this.specValueAdvicePrice];

      return Object.keys(props).map(x => {
        return { key: x, value: props[x] }
      });
      // END BESPOKE ROOD
    },
    // BESPOKE ROOD
    advicePrice () {
      var formattedPrice;
      let advicePrice = this.productDetails.properties[this.specValueAdvicePrice];
      if (advicePrice !== undefined) {  
        advicePrice = advicePrice.replace(',', '.');
        formattedPrice = `€ ${parseFloat(advicePrice).toFixed(2).replace(".", ",")}`
      }
      return formattedPrice;
    },
    // END BESPOKE ROOD
    images () {
      let images = [];

      images.push(this.productDetails.imageUrl)

      this.productDetails.images.forEach(element => {
        images.push(element);
      });

      return images
    }
  },
  updated () {
    if (this.$refs.productDescription !== undefined) {
      this.productDescriptionHeight = this.$refs.productDescription.clientHeight;
    }
  },
  created () {
    this.initDetails();
  },
  methods: {
    ...mapActions('productDetails', ['initDetails'])
  }
}
</script>

<style>

</style>
